import PropTypes from 'prop-types'
import React from 'react'
import styles from './styles.scss'

const AutocompleteItem = ({
  isHighlighted,
  className,
  children,
  onMouseEnter,
  onClick,
}) => (
  <li
    className={`${styles.autocomplete_item} ${isHighlighted ? styles.highlighted : ''} ${className}`}
    onMouseEnter={onMouseEnter}
    onClick={onClick}
    onKeyPress={() => {}}
    role="presentation"
  >
    {children}
  </li>
)

AutocompleteItem.defaultProps = {
  isHighlighted: false,
  className: '',
  children: [],
  onMouseEnter: f => f,
  onClick: f => f,
}

AutocompleteItem.propTypes = {
  isHighlighted: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.any,
  onMouseEnter: PropTypes.func,
  onClick: PropTypes.func,
}

export default AutocompleteItem



// WEBPACK FOOTER //
// ./components/AutocompleteItem/index.jsx